import { Smartphone, Share, Plus, MoreVertical, CheckCircle2 } from "lucide-react";
import { isStandalone } from "@/lib/push";

export function InstallAppCard() {
  const installed = isStandalone();
  return (
    <div className="card-immo p-5" data-testid="install-app-card">
      <div className="flex items-center gap-2.5 mb-3">
        <div className="w-9 h-9 rounded-xl bg-[#FC82ED]/15 border border-[#FC82ED]/30 flex items-center justify-center text-[#FC82ED]"><Smartphone size={18} /></div>
        <h3 className="font-display font-bold text-base">Installa l'app sul telefono</h3>
      </div>
      {installed ? (
        <div className="flex items-center gap-2 text-sm text-emerald-600" data-testid="install-done">
          <CheckCircle2 size={16} /> App installata. Aprila dall'icona nella schermata Home.
        </div>
      ) : (
        <>
          <p className="text-sm text-[var(--muted)] mb-4">Aggiungi Immobilart alla schermata Home per aprirla come un'app a schermo intero e ricevere le notifiche.</p>
          <div className="space-y-3">
            <div className="rounded-lg border border-[var(--border)] p-3">
              <div className="text-xs font-bold uppercase tracking-wide text-slate-500 mb-2">iPhone / iPad (Safari)</div>
              <ol className="text-sm space-y-1 text-slate-700">
                <li className="flex items-center gap-2">1. Tocca <Share size={14} className="inline text-[#FC82ED]" /> Condividi</li>
                <li className="flex items-center gap-2">2. Scegli <Plus size={14} className="inline text-[#FC82ED]" /> “Aggiungi alla schermata Home”</li>
                <li>3. Apri Immobilart dalla nuova icona</li>
              </ol>
            </div>
            <div className="rounded-lg border border-[var(--border)] p-3">
              <div className="text-xs font-bold uppercase tracking-wide text-slate-500 mb-2">Android (Chrome)</div>
              <ol className="text-sm space-y-1 text-slate-700">
                <li className="flex items-center gap-2">1. Tocca il menu <MoreVertical size={14} className="inline text-[#FC82ED]" /> in alto a destra</li>
                <li>2. Scegli “Installa app” (o “Aggiungi a schermata Home”)</li>
                <li>3. Conferma l'installazione</li>
              </ol>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
